// extracted by mini-css-extract-plugin
export default {"edit_part":"edit_edit_part__SAX-l","edit":"edit_edit__EBXM7"};